var _text, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#d52121",
    fontFamily: "Gotham-Bold, Gotham",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "-.05em",
    transform: "translate(5 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#c4362d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5
  }))));
}
export default SvgError;